<template>
    <div class="page-loading-spinner position-relative">
        <!--/* Spinner */-->
        <div
            v-show="isLoading"
            class="loading-progress"
            :class="loadingProgressClasses"
        >
            <LoadingIndicatorCircular class="progress-indicator" :size="50" type="undetermined" />

            <p v-if="isInitialLoading" class="visually-hidden" role="status">
                Chargement des informations de la page en cours.
            </p>

            <p v-if="isRefreshLoading" class="visually-hidden" role="status">
                Actualisation des informations de la page en cours.
            </p>
        </div>
    </div>
</template>

<script lang="ts">

import LoadingIndicatorCircular from "../ob1/LoadingIndicatorCircular.vue";

export default {
    name: "PageLoadingSpinner",
    components: {LoadingIndicatorCircular},
    props: {
        isInitialLoading: {
            type: Boolean,
            required: false,
            default: false
        },
        isRefreshLoading: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    computed: {
        isLoading: function() {
            return this.isInitialLoading || this.isRefreshLoading
        },
        loadingProgressClasses: function() {
            return {
                "loading-progress-initial": this.isInitialLoading,
                "loading-progress-refresh": !this.isInitialLoading,
            }
        }
    },
    mounted() {
        // suppression de l'auto scrolling
        // si la page est ancrée en bas lors du loading
        // la page peut rester ancrée en bas après la disparition du loader
        if ('scrollRestoration' in history) {
            history.scrollRestoration = 'manual';
        }
    }
}

</script>

<style scoped lang="scss">

.loading-progress {
    z-index: 1000;
}

.loading-progress .progress-indicator {
    position: absolute;
    top: 50%;
    left: 50%;
}

.loading-progress-initial {
    min-height: 100dvh;
    background: rgba(255, 255, 255);
}

.loading-progress-refresh {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    color: #ffffff;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    background: rgba(255, 255, 255, 0.6);
}

</style>
